import { camelCase } from 'es-toolkit';

import { Box, FieldSet, Label, LabeledControl, Radio } from '@zillow/constellation-10';

import InfoTooltip from '../InfoTooltip';

import type { FeeDictionaryItemDisplayDto } from '@zg-rentals/ts-rental-manager-api-beta-client';

type Option = {
  value: string;
  label: string;
};
type Props = {
  value: string;
  onChange: (value: string) => void;
  enums: Record<string, FeeDictionaryItemDisplayDto> | null;
  disabled?: boolean;
  required?: boolean;
  label: string;
  tooltipContent?: string;
  orientation?: 'horizontal' | 'vertical';
};
const FeeRadioGroupField = ({
  onChange,
  enums,
  disabled,
  value,
  required,
  label,
  tooltipContent = '',
  orientation = 'vertical',
}: Props) => {
  const radioOptions = [] as Array<Option>;
  if (enums) {
    Object.keys(enums).forEach((key) => {
      const { displayName } = enums[key];
      radioOptions.push({
        value: key,
        label: displayName,
      });
    });
  }

  const renderLabel = () => {
    if (tooltipContent) {
      return (
        <Box css={{ display: 'flex', flexDirection: 'row' }}>
          <Label optional={!required}>{label}</Label>
          <InfoTooltip bodyContent={tooltipContent} />
        </Box>
      );
    }
    return <Label optional={!required}>{label}</Label>;
  };

  if (orientation === 'horizontal') {
    return (
      <FieldSet disabled={disabled} required={required} legend={renderLabel()}>
        <Box css={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)' }}>
          {radioOptions.map((option, index) => (
            <Box key={index}>
              <LabeledControl
                key={index}
                label={<Label optional={!required}>{option.label}</Label>}
                onChange={() => onChange(option.value)}
                control={
                  <Radio
                    name={`LabeledControl-${label}`}
                    checked={option.value === value}
                    data-testid={`CostsAndFeesFields-${camelCase(option.label)}RadioButton`}
                  />
                }
              />
            </Box>
          ))}
        </Box>
      </FieldSet>
    );
  }

  return (
    <FieldSet disabled={disabled} required={required} legend={renderLabel()}>
      {radioOptions.map((option, index) => (
        <LabeledControl
          key={index}
          label={<Label optional={!required}>{option.label}</Label>}
          onChange={() => onChange(option.value)}
          control={
            <Radio
              name={`LabeledControl-${label}`}
              checked={option.value === value}
              data-testid={`CostsAndFeesFields-${camelCase(option.label)}RadioButton`}
            />
          }
        />
      ))}
    </FieldSet>
  );
};

export default FeeRadioGroupField;
